import React from "react";
import StraightLine from "../BuildingSoftwareSection/BuildingSoftwareImages/straightLine.png";

const LeftSide = ({ person }) => {
  return (
    <div
      className="
        left 
        flex flex-col justify-center 
        lg:w-1/2 
        px-4 sm:px-6 lg:px-0 
        [@media(min-width:1800px)]:items-start
      "
    >
      {/* === Heading === */}
      <p className="text-2xl sm:text-3xl lg:text-[28px] text-[#1a202c] font-bold pb-6">
        Build the right team to scale
      </p>

      {/* === Description === */}
      <p className="text-[16px] sm:text-[17px] lg:text-[18px] leading-7 lg:w-[534px] text-[#4a5568] pb-6">
        Finding the right talent is not easy. We help you find the talent that
        suits your needs, follows your processes, and sticks with you long term
        (not the case with freelancers).
      </p>

      <p className="text-[#2d3748] lg:text-[18px] font-normal pb-6">
        Our <span className="text-[#b0397e] font-semibold">delivery model</span>{" "}
        helps you cut costs and deliver within budget.
      </p>

      {/* === Quote Section === */}
      <div className="flex items-start gap-4 pb-6">
        <img
          src={StraightLine}
          className="w-[3px] h-[87px]"
          alt="straight line"
        />
        <p className="text-[#ab488d] font-light text-[15px] sm:text-[16px] leading-[28px] sm:leading-[30px] max-w-[440px]">
          "Simform is quick to identify larger problems with the software, so we
          decided to expand our scope to build new modules."
        </p>
      </div>

      {/* === Person Info === */}
      <div className="flex items-center gap-3 sm:gap-4 text-[15px] sm:text-[16px]">
        <img
          src={person}
          className="w-[38px] h-[38px] sm:w-[41px] sm:h-[41px]"
          alt="Person"
        />
        <div>
          <p className="text-[#1a202c] font-medium leading-tight">
            Jeewa Markram
          </p>
          <p className="text-[#718096] text-sm sm:text-[15px]">CEO</p>
        </div>
      </div>
    </div>
  );
};

export default LeftSide;
